import { useContext } from 'react';
import { BusinessContext } from '../context/BusinessContextObject';

/**
 * Custom React hook to access the current value of the `BusinessContext`.
 *
 * @throws {Error} Throws an error if used outside of a `BusinessDataProvider`.
 * @returns The current context value provided by `BusinessDataProvider`.
 */
export function useBusinesses() {
  const context = useContext(BusinessContext);
  if (context === undefined) {
    throw new Error('useBusinesses must be used within a BusinessDataProvider');
  }
  return context;
}